// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"b063fd45","118":"7fdca3af","191":"94152aca","234":"ab8b7ffd","395":"12b52a57","422":"0e18865a","594":"98e97d11","629":"81b6bd40","837":"b0a9632c","869":"95e7d5bb"}[chunkId] + ".chunk.js";
};